<template >
  <div class="box-login elevation-2 slide-in-bottom" >
    <v-img src="../../assets/logo_inet.png" alt="logo inet" aspect-ratio="1.7" width="120" contain transition="scale-transition"></v-img>
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
      class="form-contain-center"
    >
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
        class="title-login"
        style="width: 100%;"
      ></v-text-field>

      <v-text-field
        v-model="password"
        :rules="passwordRules"
        label="Password"
        required
        class="title-login"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        @click:append="showPassword = !showPassword"
      ></v-text-field>

      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="validate"
      >
        Login
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'Boxlogin',
  data: () => ({
    showPassword: false,
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 6) || 'Password must be more than 6 characters'
    ],
    lazy: false
  }),
  methods: {
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  }
}
</script>

<style scoped>

.box-login {
  z-index: 999999999;
   position: absolute;
  top: 40%;
  left: 40%;
  transform: translate(-50%, -50%);
  width: fit-content;
  height: fit-content;
  padding: 4vw 8vw;
  background: #fff;
  border: none;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title-login {
  font-family: 'Sarabun', sans-serif;
  font-weight: 500px;
  font-size: 20px;
}

.slide-in-bottom {
  -webkit-animation: slide-in-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: slide-in-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.form-contain-center {
  width: '100%';
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@-webkit-keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(1000px);
            transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(1000px);
            transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}

</style>
